import { Navigate } from "react-router-dom";

import { RVNestedRoutingPage } from "@regal-voice/ui";
import { usePageAvailability } from "App/routes/Hooks/usePageAvilability/usePageAvailability";
import { AppPagePaths } from "App/routes/paths";

export default function RoutingRulesRouter(): JSX.Element {
    const { orchestrationPages } = usePageAvailability();

    if (!orchestrationPages.showTaskRouting) {
        return <Navigate to={AppPagePaths.fallback} />;
    }

    return <RVNestedRoutingPage />;
}
